import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppState } from "../../app";
import { DeploymentRequestScreenProcessingDivisionType } from "../../util/general-code/enums/general-codes";
import {
  PAGE_MODE as IF_LIST_PAGE_MODE,
  PAGE_TYPE as IF_LIST_PAGE_TYPE,
} from "../interface-definitions/InterfaceListPageConstant";
require("./DrawerContent.css");

export const DrawerContent = () => {
  const [appState, _setAppState] = useAppState();
  const location = useLocation();

  const hasProjectId: boolean = !!appState.pjtId;
  const hasComponentProjectId: boolean = !!appState.cpntPjtId;

  const FrJdiLink: FC<{
    label: string;
    path: string;
    menuId: string;
    search?: string;
    state?: any;
  }> = ({ label, path, menuId, search, state }) => {
    const to = {
      pathname: path,

      ...(!!search && {
        search: search,
      }),
      ...(!!state && { state: state }),
    };
    return (
      <div className="accordin">
        {
          /*isDisplayedMenu(menuId) && */ <Link
            className="accordin_item"
            to={to}
          >
            {label}
          </Link>
        }
      </div>
    );
  };

  return (
    <>
      <div className={appState.isGodMode ? "drawer_title god" : "drawer_title"}>
        <b>{appState.title}</b>
      </div>
      <div className="drawer_content">
        {/* HOME */}
        <div className="item">
          <FrJdiLink label="HOME" path="/" menuId="home" />
        </div>
        {/* Current IF Project*/}
        {hasProjectId && (
          <div className="item">
            <div className="drawer-header">
              <b>Current IF Project</b>
            </div>
            <FrJdiLink
              label="Project Detail"
              path="/project-detail"
              menuId="project-detail"
              search={`?pjtId=${appState.pjtId}`}
            />
            <FrJdiLink
              label="Project Plan"
              path="/project-plan"
              menuId="project-plan"
              search={`?pjtId=${appState.pjtId}`}
            />
            <FrJdiLink
              label="Interface Requirement List"
              path="/interface-requirement-list"
              menuId="interface-requirement-list"
              search={`?pjtId=${appState.pjtId}`}
            />
            <FrJdiLink
              label="Interface List"
              path="/interface-list"
              menuId="interface-list"
              search={`?mode=${IF_LIST_PAGE_MODE.INPUT_MODE}&pjtId=${appState.pjtId}`}
              state={{ prevPath: location.pathname }}
            />
            <FrJdiLink
              label="Component Project List"
              path="/component-project-list"
              menuId="component-project-list"
              search={`?pjtId=${appState.pjtId}`}
            />
            <FrJdiLink
              label="Interface Deployment Request List"
              path="/interface-deployment-request-list"
              menuId="interface-deployment-request-list"
              search={`?pjtId=${appState.pjtId}`}
            />
          </div>
        )}
        {/* Current Component Project*/}
        {hasComponentProjectId && (
          <>
            <b>Current Component Project</b>
            <div style={{ paddingLeft: "10px" }}>
              <FrJdiLink
                label="Component Project Detail"
                path="/component-project-detail"
                menuId="component-project-detail"
                search={`?cpntPjtId=${appState.cpntPjtId}`}
              />

              <FrJdiLink
                label="Component Deployment Request List"
                path={`/component-deployment-request-list/${appState.cpntPjtId}`}
                menuId="component-deployment-request-list"
              />
            </div>
          </>
        )}
        {/* IF Project */}
        <div className="item">
          <div className="drawer-header">
            <b>IF Project</b>
          </div>
          <FrJdiLink
            label="Create New Project"
            path="/project-plan"
            menuId="project-plan"
          />
          <FrJdiLink
            label="Project Search"
            path="/project-search"
            menuId="project-search"
          />
        </div>
        {/* Component Project */}
        <div className="item">
          <div className="drawer-header">
            <b>Component Project</b>
          </div>
          <FrJdiLink
            label="Component Project List"
            path="/component-project-list"
            menuId="component-project-list"
          />
        </div>

        {/* Protocol */}
        <div className="item">
          <div className="drawer-header">
            <b>Protocol</b>
          </div>
          <FrJdiLink
            label="Root Component List"
            path="/root-component-list"
            menuId="root-component-list"
          />

          <FrJdiLink
            label="Partner Code Maintenance"
            path="/partner-list"
            menuId="partner-list"
          />
        </div>

        {/* Interface */}
        <div className="item">
          <div className="drawer-header">
            <b>Interface</b>
          </div>
          <FrJdiLink
            label="IF List"
            path="/interface-list"
            menuId="interface-list"
            search={`?mode=${IF_LIST_PAGE_MODE.REF_MODE}&type=${IF_LIST_PAGE_TYPE.PRD_PJ_TYPE}`}
          />
        </div>

        {/* Deployment */}
        <div className="item">
          <div className="drawer-header">
            <b>Deployment</b>
          </div>
          <FrJdiLink
            label="Interface Deployment Request List"
            path="/interface-deployment-request-list"
            menuId="interface-deployment-request-list"
          />
          <FrJdiLink
            label="Component Deployment Request List"
            path="/component-deployment-request-list"
            menuId="component-deployment-request-list"
            search={`?screenMode=${DeploymentRequestScreenProcessingDivisionType.NORMAL_MODE}`}
          />
          <FrJdiLink
            label="Environment Copy"
            path="/environment-copy"
            menuId="environment-copy"
          />
        </div>

        {/* Master */}
        <div className="item">
          <div className="drawer-header">
            <b>Master</b>
          </div>
          <FrJdiLink
            label="Data Kind Maintenance"
            path="/data-kind-maintenance"
            menuId="data-kind-maintenance"
          />
          <FrJdiLink
            label="File Layout Maintenance"
            path="/file-layout-maintenance"
            menuId="file-layout-maintenance"
          />
          <FrJdiLink
            label="User Role Maintenance"
            path="/user-role-maintenance"
            menuId="user-role-maintenance"
          />
        </div>
      </div>
    </>
  );
};
